import styled, { css } from 'styled-components';
import COLORS from '../../../../constants/COLORS';
import COLORS_MARKETPLACE from '../../../../constants/COLORS_MARKETPLACE';
import mixins from '../../../../styles/mixins';
import arrowDownIcon from '../../../../images/arrowDown.svg';
import coopIcon from '../../../../images/cooperation.svg';
import fiveStarsIcon from '../../../../images/5star.svg';
import wifiIcon from '../../../../images/wifi.svg';
import goodViewIcon from '../../../../images/goodView.svg';
import invalidIcon from '../../../../images/invalid.svg';
import openedEmailIcon from '../../../../images/openedEmail.svg';
import { TTicketDetails } from '../../../../types/ticket';
import { lighten } from 'polished';

export default {
  AnnouncementItem: styled.div<{ isBottomBordersRounded?: boolean }>`
    position: relative;
    padding: 16px;
    border-radius: 16px;

    background-color: ${COLORS.WHITE};

    ${({ isBottomBordersRounded }) =>
      isBottomBordersRounded &&
      css`
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      `}

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: ${COLORS_MARKETPLACE.GREY};
    }

    &::before {
      left: -8px;
    }
    &::after {
      right: -8px;
    }
  `,
  Title: styled.h4`
    margin: 0;

    & > span {
      &:not(:first-child) {
        position: relative;
        padding-left: 11px;

        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 4px;
          width: 3px;
          height: 3px;

          background-color: ${COLORS_MARKETPLACE.BLACK};

          border-radius: 50%;
          transform: translateY(-50%);
        }
      }
    }
  `,
  Count: styled.span`
    opacity: 0.4;
  `,
  Price: styled.div`
    margin-top: 4px;
  `,
  Note: styled.div`
    width: 100%;
    margin-top: 4px;

    font-size: 12px;
    line-height: 1.3;
    opacity: 0.4;
  `,
  AnnouncementBtn: styled.button`
    ${mixins.btnReset}
    ${mixins.h3}

    padding: 12px 8px;

    border-radius: 8px;

    color: ${COLORS.WHITE};

    background-color: ${({ theme }) => theme.buttonBackground || COLORS_MARKETPLACE.SECONDARY};

    transition: 0.1s linear;

    &:hover,
    &:focus-visible {
      background-color: ${({ theme }) =>
        lighten(0.1, theme.buttonBackground) || COLORS_MARKETPLACE.PRIMARY};
    }

    img {
      vertical-align: middle;
      margin-top: -3px;
    }
  `,
  Header: styled.header`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 12px;
  `,
  DetailBtn: styled.button<{ isActive: boolean }>`
    ${mixins.btnReset}

    position: relative;

    padding-right: 24px;

    ${mixins.h3}

    color: ${({ isActive }) =>
      isActive ? COLORS_MARKETPLACE.PRIMARY : COLORS_MARKETPLACE.SECONDARY};

    transition: 0.1s ease-in;

    &:hover {
      color: ${COLORS_MARKETPLACE.PRIMARY};
    }

    &::after {
      content: '';

      position: absolute;
      top: 50%;
      right: 0;

      width: 16px;
      height: 16px;

      background-image: url(${arrowDownIcon});
      background-position: center;
      background-repeat: no-repeat;

      transform: translateY(-50%) rotate(${({ isActive }) => (isActive ? '180deg' : '0')});
      transition: 0.1s ease-in;
    }
  `,
  FlexHelper: styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;

    min-height: 41px;
  `,
  IsBrokerTicket: styled.p`
    margin: 0;
    padding-left: 32px;

    font-size: 12px;
    line-height: 2;

    background-image: url(${coopIcon});
    background-position: center left;
    background-repeat: no-repeat;
  `,
  Center: styled.div`
    margin-bottom: 12px;
  `,
  Details: styled.div`
    padding: 16px;

    border-top: 1px dashed rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;

    background-color: ${COLORS.WHITE};
  `,
  DetailsList: styled.ul`
    ${mixins.listReset}
  `,
  DetailItem: styled.li<{ type: TTicketDetails }>`
    padding-left: 36px;

    font-size: 12px;
    line-height: 2;

    background-image: ${({ type }) => {
      let url;

      switch (type) {
        case 'fiveStar':
          url = fiveStarsIcon;
          break;
        case 'goodView':
          url = goodViewIcon;
          break;
        case 'invalid':
          url = invalidIcon;
          break;
        case 'speed':
          url = openedEmailIcon;
          break;
        case 'wifi':
          url = wifiIcon;
          break;
        default:
          break;
      }

      return `url(${url})`;
    }};
    background-position: center left;
    background-repeat: no-repeat;

    & + & {
      margin-top: 4px;
    }
  `,
};
